import React from 'react';
import { Box, Flex, Grid, HStack, Text, Icon, Avatar, Button } from '@chakra-ui/react';
import { FiUsers, FiMap, FiActivity, FiArrowRight } from 'react-icons/fi';
import FichaPreviewPanel from 'views/Dashboard/Profile/components/Fichas/FichaPreviewPanel';

const KIND_CONFIG = {
  pickup:      { label: 'RETIRO ANTICIPADO',      color: '#DC4D20', bg: 'coral.soft', icon: FiUsers },
  pedagogical: { label: 'SALIDA PEDAGÓGICA',       color: '#6D28D9', bg: 'lav.bg',     icon: FiMap },
  sick:        { label: 'SALIDA POR ENFERMEDAD',   color: '#0F766E', bg: 'mint.bg',    icon: FiActivity },
};

// Pantalla de resumen mostrada justo después de confirmar una salida cuya
// ficha se acaba de firmar (no al reusar una ya existente, ver
// ScannerShell::_doLog) — a la izquierda el contexto (alumno, o el curso
// para Salida Pedagógica), a la derecha la ficha ya guardada de verdad
// (con logo/PDF), reusando FichaPreviewPanel tal cual (mismo componente que
// Perfil > Fichas). El operador cierra con "Escanear siguiente" cuando ya
// revisó lo que quedó registrado.
const ExitSummaryView = ({ summary, onDone }) => {
  if (!summary) return null;
  const cfg = KIND_CONFIG[summary.kind] ?? KIND_CONFIG.pickup;
  const studentName = [summary.student?.first_name, summary.student?.last_name].filter(Boolean).join(' ');

  return (
    <Box w="100%" maxW={{ base: '95vw', lg: '1100px' }} m="auto" py={2} position="relative" zIndex={1}>
      <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap="18px" alignItems="start">
        <Box bg="white" border="1px solid" borderColor="cream.line" borderRadius="20px" p="24px" position={{ base: 'static', lg: 'sticky' }} top="20px">
          <HStack spacing="12px" mb="20px">
            <Flex w="54px" h="54px" borderRadius="14px" bg={cfg.bg} align="center" justify="center" flexShrink={0}>
              <Icon as={cfg.icon} boxSize="26px" color={cfg.color} />
            </Flex>
            <Box minW={0}>
              <Text fontSize="13.5px" fontWeight="800" color={cfg.color} letterSpacing=".04em">{cfg.label}</Text>
              <Text fontSize="14.5px" color="ink.400" fontWeight="600">
                {new Date().toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })} hrs — registrada
              </Text>
            </Box>
          </HStack>

          {summary.kind === 'pedagogical' ? (
            <Box mb="20px">
              <Text fontSize="12.5px" fontWeight="800" color="ink.400" textTransform="uppercase" letterSpacing=".05em" mb="4px">
                Curso
              </Text>
              <Text fontSize="22px" fontWeight="800" color="ink.900">{summary.courseLabel ?? '—'}</Text>
              {studentName && (
                <Text fontSize="14px" color="ink.400" fontWeight="500" mt="4px">
                  Registrado: {studentName}
                </Text>
              )}
            </Box>
          ) : (
            <HStack spacing="12px" mb="20px">
              <Avatar
                src={summary.student?.avatar_url || null}
                name={studentName}
                size="lg" borderRadius="12px" bg="coral.soft" color="coral.700"
              />
              <Box minW={0}>
                <Text fontSize="18px" fontWeight="800" color="ink.900" noOfLines={1}>{studentName}</Text>
                <Text fontSize="14px" color="ink.400" fontWeight="500">RUT {summary.student?.rut}</Text>
              </Box>
            </HStack>
          )}

          <Button
            w="full" h={{ base: '60px', md: '64px' }} bg={cfg.color} color="#fff" _hover={{ opacity: 0.9 }}
            borderRadius="14px" fontWeight="700" fontSize={{ base: '17px', md: '18px' }}
            rightIcon={<Icon as={FiArrowRight} />}
            onClick={onDone}
          >
            Escanear siguiente
          </Button>
        </Box>

        <Box>
          <FichaPreviewPanel item={summary.fichaItem} customer={summary.customer} />
        </Box>
      </Grid>
    </Box>
  );
};

export default ExitSummaryView;
